import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ExperienceManageState } from "./reducers-experiences";

/**
 * Top level selector for the ExperienceManageState
 */
export const experienceManageState = createFeatureSelector<ExperienceManageState>('experiencesManage');

export const getFoundExperiences = createSelector(
    experienceManageState,
    (state: ExperienceManageState) => state.entityData
);

export const getExperienceToEdit = createSelector(
    experienceManageState,
    (state: ExperienceManageState) => state.editEntityData
);

export const getExperienceToView = createSelector(
    experienceManageState,
    (state: ExperienceManageState) => state.viewEntityData
);

export const getExperienceCopyMode = createSelector(
    experienceManageState,
    (state: ExperienceManageState) => state.isCopy
);